module.exports = __webpack_public_path__ + "static/img/37.a5e12a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/37.png
// module id = HUaw
// module chunks = 0